module.exports = __webpack_public_path__ + "static/alert-system-alert-do-430b5c3d384801fe42e56e2b877234e0.png";